import { render } from "./vsetcount.vue?vue&type=template&id=0fb2bd9d&scoped=true"
import script from "./vsetcount.vue?vue&type=script&lang=js"
export * from "./vsetcount.vue?vue&type=script&lang=js"

import "./vsetcount.vue?vue&type=style&index=0&id=0fb2bd9d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb2bd9d"]])

export default __exports__